const options = {
  5: "bg-slate-100/5",
  10: "bg-slate-100/10",
  25: "bg-slate-100/25",
  50: "bg-slate-100/50",
  75: "bg-slate-100/75",
  90: "bg-slate-100/90",
  100: "bg-slate-100",
};

const from = {
  5: "from-slate-100/5",
  10: "from-slate-100/10",
  25: "from-slate-100/25",
  50: "from-slate-100/50",
  75: "from-slate-100/75",
  90: "from-slate-100/90",
  100: "from-slate-100",
};

export default function getBackgroundSlate100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
